<template>
	<div>
		<NuxtLink
			:to="blok.link"
			class="cms-element-image flex relative w-full h-full pb-[68%] cursor-pointer group"
		>
			<div
				class="absolute w-full h-full z-10 flex items-center justify-center bg-black/30"
			>
				<button
					class="button-banner-button !bg-transparent group-hover:!bg-blue-light"
				>
					{{ blok.name }}
				</button>
			</div>

			<NuxtImg
				:src="imageSrc"
				:alt="blok.name"
				:loading="lazyLoadImages ? 'lazy' : 'eager'"
				:preload="!lazyLoadImages"
				format="webp"
				class="h-full w-full absolute inset-0 object-cover object-center"
				sizes="sm:10vw md:50vw lg:70vw 70vw"
			/>
		</NuxtLink>
	</div>
</template>

<script setup lang="ts">
import type { CategoryHeroBlok } from "~/types/storyblok/storyblok";

interface Props {
	blok: CategoryHeroBlok;
	lazyLoadImages?: boolean;
}
const { blok } = defineProps<Props>();

const imageSrc = computed(() => blok?.image?.filename + "?format=webp&w=516");
</script>
